module.exports = __webpack_public_path__ + "static/media/04-full.c58223e1.jpg";